import C from 'actionTypes'

const defaultState = {
  jointOwners: []
}

const jointOwners = (state = defaultState, action) => {
  switch (action.type) {
    case C.SET_JOINT_OWNERS: {
      const {
        data: { jointOwnersInfo: { data },
          financialAccountId
        }
      } = action

      return { 
        ...state,
        jointOwners: [{
          financialAccountId,
          data: data[0] // It's always just one joint account per personal one account
        }]
      }
    }

    case C.UPDATE_JOINT_OWNER: {
      const {
        data: {
          data
        },
      } = action
      const updatedjointOwnerId = data.id
      const updatedJoinOwners = state.jointOwners.map((jointOwner) => {
        if (jointOwner.data.id === updatedjointOwnerId) {
          return { ...jointOwner, data }
        }
        return jointOwner
      })
      return {
        ...state,
        jointOwners: updatedJoinOwners,
      }
    }

    case C.CLEAR_JOINT_OWNERS: {
      return {
        ...state,
        jointOwners: []
      }
    }

    default:
      return state
  }
}

export default jointOwners



// WEBPACK FOOTER //
// ./src/reducers/jointOwners.js